import React from 'react';
import { useTranslation } from 'react-i18next';
import type { AddonCardProps } from './types';
import { getCurrency, formatPrice } from './utils';
import './styles/index.less';

const AddonCard: React.FC<AddonCardProps> = ({ addon, onSelect, selected }) => {
  const { t, i18n } = useTranslation();
  const currency = getCurrency(i18n.language);

  return (
    <div 
      className={`addon-card ${selected ? 'selected' : ''}`}
      onClick={onSelect}
    >
      <div className="addon-header">
        <h4 className="addon-name">{addon.name}</h4>
        <div className="addon-price">{formatPrice(addon.price, currency)}</div>
        <div className="addon-hours">
          <span>{t('minutes', { time: addon.hours })}</span>
        </div>
        <p className="addon-description">{addon.description}</p>
      </div>

      <button 
        className={`addon-button ${selected ? 'selected-addon' : 'default'}`}
      >
        {selected ? (t('account.selected') || 'Selected') : (t('account.selectPackage') || 'Select Package')}
      </button>
    </div>
  );
};

export default AddonCard;